/*
 * @Author: Ryan
 * @Date: 2025-12-25
 * @Description: Shared utility for scrolling to top of page (landing pages)
 */

/**
 * Scrolls to the top of the page with smooth behavior
 * Targets Next.js __next container or body's first child element
 */
export const scrollToTop = (duration: number = 500) => {
  const nextContainer = document.getElementById('__next');
  const targetElement = nextContainer || (document.body.firstElementChild as HTMLElement);

  if (!targetElement) return;

  const start = targetElement.scrollTop || window.pageYOffset;
  const startTime = performance.now();

  const animateScroll = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const easeProgress = 1 - Math.pow(1 - progress, 3);
    const scrollPosition = start * (1 - easeProgress);

    if (
      targetElement === nextContainer ||
      targetElement === document.body.firstElementChild
    ) {
      targetElement.scrollTop = scrollPosition;
    }
    window.scrollTo(0, scrollPosition);

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
};
